"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_GROUPS = void 0;
var COOKIE_GROUPS;
(function (COOKIE_GROUPS) {
    COOKIE_GROUPS["STRICTLY_NECESSARY"] = "C0001";
    COOKIE_GROUPS["PERFORMANCE"] = "C0002";
    COOKIE_GROUPS["FUNCTIONALITY"] = "C0003";
    COOKIE_GROUPS["MARKETING"] = "C0004";
    COOKIE_GROUPS["SOCIAL_MEDIA"] = "C0005";
})(COOKIE_GROUPS || (exports.COOKIE_GROUPS = COOKIE_GROUPS = {}));
//# sourceMappingURL=types.js.map